import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import {
  CreateWalletAcknowledgements,
  CreateWalletSeedPhrase,
  CreateWalletSeedPhraseConfirm,
} from '@root/features/wallet/create-wallet/ui'

import type { CreateWalletFlowModel } from '../atoms/reatom-create-wallet-flow'

type Props = {
  model: CreateWalletFlowModel
}

export const CreateWalletFlow: React.FC<Props> = ({ model }) => {
  const [step, setStep] = useAtom(model.step)

  const [mnemonics] = useAtom(model.mnemonic)

  return match(step)
    .with('acknowledgements', () => <Acknowledgements model={model} />)
    .with('seed-phrase', () => (
      <SeedPhrase
        mnemonics={mnemonics}
        onNext={() => {
          setStep('seed-phrase-confirm')
        }}
      />
    ))
    .with('seed-phrase-confirm', () => <SeedPhraseConfirm model={model} />)
    .exhaustive()
}

const Acknowledgements = styled(CreateWalletAcknowledgements)`
  height: 100%;
  padding-block-end: 10px;
`
const SeedPhrase = styled(CreateWalletSeedPhrase)`
  height: 100%;
  padding-block: 10px;
`
const SeedPhraseConfirm = styled(CreateWalletSeedPhraseConfirm)`
  height: 100%;
  padding-block: 10px;
`
